import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAreaDel = async (credentials, data) => {
    const body = {
        service: "RNHAreaDel",
        params: {
            rnhAreaCod: data?.cod,
            rnhAreaVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
